import { motion } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";

//@ts-ignore
const Pagination = ({
  //@ts-ignore
  pageInfo,
  //@ts-ignore
  handlePageChange,
  //@ts-ignore
  title,
  //@ts-ignore
  Icon,
  showNavigation = true
}) => {
  // Animation variants for buttons
  const buttonVariants = {
    hover: { scale: 1.05 },
    tap: { scale: 0.95 },
    disabled: { scale: 1 }
  };

  // Common button classes
  const buttonBaseClasses = "lp-p-2 lp-text-[#DDB889] lp-border lp-rounded-full lp-transition-all lp-duration-200";
  const buttonActiveClasses = "lp-border-[#DDB889]/20 lp-hover:border-[#DDB889]/40 lp-hover:bg-[#DDB889]/10 lp-hover:text-[#DDB889] lp-shadow-[0_0_10px_rgba(221,184,137,0.05)] lp-hover:shadow-[0_0_15px_rgba(221,184,137,0.1)]";
  const buttonDisabledClasses = "lp-border-gray-700/50 lp-opacity-50 lp-cursor-not-allowed";

  return (
    <div className="lp-flex lp-justify-between lp-items-center lp-mb-6 lp-px-2">
      {showNavigation && (
        <motion.button
          onClick={() => handlePageChange('previous')}
          disabled={!pageInfo?.hasPreviousPage}
          className={`${buttonBaseClasses} ${
            pageInfo?.hasPreviousPage ? buttonActiveClasses : buttonDisabledClasses
          }`}
          variants={buttonVariants}
          whileHover={pageInfo?.hasPreviousPage ? "hover" : "disabled"}
          whileTap={pageInfo?.hasPreviousPage ? "tap" : "disabled"}
        >
          <ChevronLeft className="lp-h-6 lp-w-6" />
        </motion.button>
      )}

      <motion.div
        className="lp-flex lp-items-center lp-space-x-4"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <div className="lp-h-[1px] lp-w-16 lp-bg-gradient-to-r lp-from-transparent lp-via-[#DDB889]/20 lp-to-[#DDB889]/40"></div>

        <motion.div
          className="lp-flex lp-items-center lp-gap-2 lp-px-2 lp-py-1 lp-rounded-xl lp-backdrop-blur-sm"
          whileHover={{ scale: 1.02 }}
          transition={{ duration: 0.2 }}
        >
          <Icon className="lp-hidden md:lp-block lp-text-[#DDB889] lp-opacity-80" size={24} />
          <h3 className="lp-text-lg md:lp-text-2xl lp-font-medium lp-text-center lp-text-[#DDB889] lp-font-boska">
            {title}
          </h3>
        </motion.div>

        <div className="lp-h-[1px] lp-w-16 lp-bg-gradient-to-l lp-from-transparent lp-via-[#DDB889]/20 lp-to-[#DDB889]/40"></div>
      </motion.div>

      {showNavigation && (
        <motion.button
          onClick={() => handlePageChange('next')}
          disabled={!pageInfo?.hasNextPage}
          className={`${buttonBaseClasses} ${
            pageInfo?.hasNextPage ? buttonActiveClasses : buttonDisabledClasses
          }`}
          variants={buttonVariants}
          whileHover={pageInfo?.hasNextPage ? "hover" : "disabled"}
          whileTap={pageInfo?.hasNextPage ? "tap" : "disabled"}
        >
          <ChevronRight className="lp-h-6 lp-w-6" />
        </motion.button>
      )}
    </div>
  );
};

export default Pagination;
